import React from 'react';
import { Field } from 'redux-form';
import StepTitle from '../../../common/StepTitle';
import ContractSelectorField from './ContractDetails/ContractSelectorField';
import { css } from 'emotion';
import { useTranslation } from 'react-i18next';

const contractSelectorStyle = css`
  max-height: 400px;
  overflow: auto;
`;

export default function SelectExistingContract({ contracts }) {
  const { t } = useTranslation();

  return (
    <>
      <StepTitle icon="product-pricing-terms-l" title={t('createContract:selectExistingContract.header')} />
      <Field
        component={ContractSelectorField}
        contracts={contracts}
        name="selectedContract"
        className={contractSelectorStyle}
      />
    </>
  );
}
